import React, {useMemo} from "react";
import {useTranslation} from "react-i18next";

import IncidentHistoricalCounts from "./IncidentHistoricalCounts";
import IncidentSeasonCounts from "./IncidentSeasonCounts";
import MDBox from "materialDashboard/components/MDBox";
import MDTypography from "materialDashboard/components/MDTypography";
import {useIncidentRegistryQuery} from "../../pages/Incidents/query";
import IncidentAspectPolar from "./IncidentAspectPolar";
import IncidentDailyCounts from "./IncidentDailyCounts";
import RegionAutocomplete from "../inputs/RegionAutocomplete";
import ProvinceAutocomplete from "../inputs/ProvinceAutocomplete";


const IncidentsGraphsBase = ({timeseriesQuery, regionId, provinceId, setSelectedRegionId, setSelectedProvinceId}) => {
    const {t} = useTranslation("graphs");
    const registryQuery = useIncidentRegistryQuery();
    const registry = registryQuery.data || {};

    const data = useMemo( () => (
        timeseriesQuery.data ?
            timeseriesQuery.data.dates.map((date, index) => {
                return {
                    date: new Date(date),
                    numberOfPeopleInvolved: timeseriesQuery.data.numberOfPeopleInvolved?.[index],
                    numberOfPeopleCaught: timeseriesQuery.data.numberOfPeopleCaught?.[index],
                    numberOfPeopleInjured: timeseriesQuery.data.numberOfPeopleInjured?.[index],
                    numberOfPeopleUninjured: timeseriesQuery.data.numberOfPeopleUninjured?.[index],
                    numberOfDeaths: timeseriesQuery.data.numberOfDeaths?.[index],
                    category: timeseriesQuery.data.category?.[index],
                    subcategory: timeseriesQuery.data.subcategory?.[index],
                    aspect: timeseriesQuery.data.aspect?.[index],
                    dangerScaleBulletin: timeseriesQuery.data.dangerScaleBulletin?.[index],
                }
            })
            :
            []
    ), [timeseriesQuery.data])

    return <MDBox sx={{width: "100%", maxWidth: "100%", minWidth: 0, display: "flex", flexDirection: "column", gap: 4 }}>

        <MDBox sx={{display: "flex", gap: 2, flexWrap: "wrap"}}>
            <RegionAutocomplete value={regionId} onChange={setSelectedRegionId} sx={{width: 200}}/>
            <ProvinceAutocomplete value={provinceId} onChange={setSelectedProvinceId} sx={{width: 200}} regionId={regionId}/>
        </MDBox>

        <MDBox>
            <MDTypography variant="h5">{t('incidentHistoricalCounts.title')}</MDTypography>
            <IncidentHistoricalCounts data={data}/>
        </MDBox>
        <div>
            <MDTypography variant="h5">{t('incidentSeasonCounts.title')}</MDTypography>
            <IncidentSeasonCounts data={data} registry={registry}/>
        </div>
        <div>
            <MDTypography variant="h5">{t('incidentAspectPolar.title')}</MDTypography>
            <IncidentAspectPolar data={data} registry={registry}/>
        </div>
        <div>
            <MDTypography variant="h5">{t('incidentDailyCounts.title')}</MDTypography>
            <IncidentDailyCounts data={data}/>
        </div>
    </MDBox>
}


export default IncidentsGraphsBase;